module.exports = "data:image/gif;base64,R0lGODlhyAAJAJEDAPb29sTExAAAAP///yH5BAEAAAMALAAAAADIAAkAAAJMjI+py+0Po5y02uuA3rz7D4biSJbmiabqKg7uC8fyTNf2jef6zvf+DwwKh8Si8YhMKpfMpvMJjUqn1CpUgMVat9yuMOsNi8c0AZlcAAA7"


/*****************
 ** WEBPACK FOOTER
 ** ./extjs/resources/themes/images/gray/button/s-arrow-bo.gif
 ** module id = 435
 ** module chunks = 0
 **/